import { render, staticRenderFns } from "./version.vue?vue&type=template&id=685351d4"
import script from "./version.vue?vue&type=script&lang=js"
export * from "./version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports